"use strict";

module.exports = {
    jsPattern: /\.js$/i,
    cssPattern: /\.css$/i,
    imgPattern: /\.(png|jpg|jpeg|gif|webp|ico|bmp|tiff|svg)$/i,
    urlPattern: /^(https?:\/\/[^/\r\n]+)(\/[^\r\n]*)?$/
};